import { Help, HelpParameters, HelpPanelColor } from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { FreegamePickElement } from "../FreegameBonus/FreegamePickElement";
import { IPanelFactory, PanelParams } from "../panel/IPanelFactory";
import { ButtonColors, Panel } from "../panel/panel";
import { PickBonus, PickBonusFactory } from "../PickBonus/PickBonus";
import { PickBonusElement } from "../PickBonus/PickBonusElement";
import { PickBonusParams, PickBonusPickElementParams } from "../PickBonus/PickBonusParams";
import { SlotGameType1 } from "../SlotGameType1";


export class Catillionare extends SlotGameType1
{
	// override default factory with one that creates custom freegame
	////protected override freegameBonusFactory: FreegameBonusFactory = new CatillionareFreegameBonusFactory();
	protected override pickBonusFactory:PickBonusFactory = new CatillionarePickBonusFactory();
	
	//protected panelFactory:IPanelFactory = new CatillionarePanelFactory();
	protected override helpFactory:IHelpFactory = new CatillionareHelpFactory();

	//LED COLOR
	protected override ColorLed:string="255,0,128\n";

	constructor(multigameParams: MultigameParams, initData: SlotGameInitData)
	{
		super(multigameParams, initData, "Catillionare");
		this.spinnableReelsParams.topBorderWidth=6;
		this.spinnableReelsParams.bottomBorderWidth=6;
	}

	// public PrepareFont(resourceManager: ResourceManager)
	// {
	// 	resourceManager.Add(new FontResource(this.basepath + "resources/Monky Stone.ttf", "."+ this.resid.ScopedResourceName("font")));
	// 	resourceManager.Add(new FontResource(this.basepath + "resources/Monky Stone.ttf", "."+ this.resid.ScopedResourceName(["lines", "font"])));
	// }
}

// class CatillionareFreegameBonusFactory extends FreegameBonusFactory
// {
// 	public override CreateFreegameBonus(gameName: string, params: FreegameBonusParams): FreegameBonus 
// 	{
// 		return new CatillionareFreegameBonus(gameName, params);
// 	}
// 	public override CreatePickElement(params: FreegamePickElementParams): FreegamePickElement 
// 	{
// 		return new CatillionareFreegamePickElement(params);
// 	}
// }


// class CatillionareFreegameBonus extends FreegameBonus 
// {
// 	public constructor(gameName: string, params: FreegameBonusParams ) {
// 		super(gameName, params);
// 		this.spinnableReelsParams.topBorderWidth = 6;
// 		this.spinnableReelsParams.bottomBorderWidth = 6;
// 	}
// 	protected override PicksPositions(): FreegamePickElemGeometry[] 
// 	{
// 		let geometry: FreegamePickElemGeometry[] = [];

// 		let displayWidth: number = 540;
// 		let displayHeight: number = 510;

// 		let displayRects: PixelRect[] = 
// 		[
// 			new PixelRect(21, 328, displayWidth, displayHeight),
// 			new PixelRect(363, 528, displayWidth, displayHeight),
// 			new PixelRect(705, 328, displayWidth, displayHeight),
// 			new PixelRect(1044, 528, displayWidth, displayHeight),
// 			new PixelRect(1386, 328, displayWidth, displayHeight),
// 		];

// 		// offset relative to pick rect
// 		let pickRect = new PixelRect(207,161,124,287);
// 		let awardRect = new PixelRect(207,161,124,287);

// 		for (let i = 0; i < displayRects.length; i++) 
// 		{
// 			geometry.push(new FreegamePickElemGeometry(displayRects[i], pickRect, awardRect));
// 		}

// 		return geometry;
// 	}

// 	public override OnPicked(index: number): void {
// 		//super.OnPicked(index);

// 		if (this.stateMachine.State() == FreegameStates.Pick)
// 		{
// 			// Log.Debug(this.logGroup, "Picked index " + index);

// 			// TODO check state, check index bounds
// 			this.pickedIndex = index;
// 			// protocol.Send("SelectBonusElement",{selectedElement: index});

// 			for (let i = 0; i < this.picks.length; i++) {
// 				if (i == index) {
// 					this.picks[i].BringToFront();
// 					this.picks[i].awardElem.style.fontSize = "90px";
// 					this.picks[i].awardElem.style.left = "205px";
// 					this.picks[i].awardElem.style.top = "90px";
// 				}
				
// 				else {
// 					this.picks[i].PushToBack();
// 					this.picks[i].awardElem.style.left = "205px";
// 					this.picks[i].awardElem.style.top = "90px";
// 				}
// 			}

// 			this.stateMachine.ChangeState(FreegameStates.RevealPicked);
// 		}
// 	}

// 	public override async ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void>
// 	{
// 		await super.ResourcesLoaded(resourceManager);

// 		// this.introMessageContainer.style.color = "yellow";
// 		// this.introMessageContainer.style.webkitTextStrokeWidth = "2px";
// 		// this.introMessageContainer.style.webkitTextStrokeColor = "black";
// 		// this.finalMessageContainer.style.textShadow="black 0px 1px 1px, black 0px 1px 17px, black 0px 1px 21px, black 0px 1px 2px";
		
// 		// this.pickedMessageContainer.style.webkitTextStrokeWidth="2px";
// 		// this.pickedMessageContainer.style.webkitTextStrokeColor = "black"
// 		// this.pickedMessageContainer.style.textShadow="black 0px 1px 1px, black 0px 1px 17px, black 0px 1px 21px, black 0px 1px 2px";
// 		// this.finalMessageContainer.style.webkitTextStrokeWidth="2px";
// 		// this.finalMessageContainer.style.webkitTextStrokeColor = "black";
// 		// this.finalMessageContainer.style.textShadow="black 0px 1px 1px, black 0px 1px 17px, black 0px 1px 21px, black 0px 1px 2px";
			
// 		// SetStyles(this.view.querySelector("#startfree3"), { fontSize:"35px" });
// 		// SetStyles(this.view.querySelector("#contents3"), { fontSize:"35px" });
// 		// SetStyles(this.view.querySelector(".header"), { fontSize:"70px" });
// 		// SetStyles(this.view.querySelector(".bonusName").parentElement, { fontSize:"60px", lineHeight: "100px", });
// 		// SetStyles(this.view.querySelector("#startfree1"), { fontSize:"40px" });
// 		// SetStyles(this.view.querySelector("#startfree2"), { fontSize:"40px" });
// 		// SetStyles(this.view.querySelector("#contents1"), { fontSize:"40px", lineHeight: "40px" });
// 		// SetStyles(this.view.querySelector("#contents2"), { fontSize:"40px", lineHeight: "40px" });
// 		// SetStyles(this.view.querySelector("#headerend"), { fontSize:"73px" });
// 		// SetStyles(this.view.querySelector("#startend3"), { fontSize:"36px" });

// 		// // pick instructions on pick screen
// 		// SetStyles(this.view.querySelector(".pickInstructions .pick1"), {lineHeight: "100px"});
// 	}

// 	protected override PrepareFonts(resourceManager: ResourceManager): void {
// 		resourceManager.Add(new FontResource(this.params.gameResourcesBasePath + "Monky Stone.ttf", "." + this.resid.ScopedResourceName("font") ));
// 		resourceManager.Add(new FontResource(this.params.gameResourcesBasePath + "Monky Stone.ttf", "." + this.resid.ScopedResourceName(["lines", "font"])));
// 	}
// }

//Panel Colorized
class CatillionarePanelFactory implements IPanelFactory
{
	public CreateNewPanel(params: PanelParams):Panel
	{
		return new CatillionarePanel(params);
	}
}

class CatillionarePanel extends Panel
{
	protected override ButtonBackground():ButtonColors
	{
		let color:ButtonColors ={
			backgroundButtonColor: "linear-gradient(rgb(38, 21, 15),rgb(89, 55, 35), rgb(140, 101, 66),rgb(89, 55, 35),rgb(38, 21, 15)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
			linearColor:"linear-gradient(to left , transparent, HoneyDew,transparent ) 0 10 100%",
		};
		return color;
		
	}

}

//Help Colorized
class CatillionareHelpFactory implements IHelpFactory
{
	public CreateNewHelp(params: HelpParameters):Help
	{
		return new   CatillionareHelp(params);
	}
}

class CatillionareHelp extends Help
{
	protected override BackgroundPanel():HelpPanelColor
	{
		let color:HelpPanelColor = {
			backgroundPanelColor: "linear-gradient(rgb(38, 21, 15),rgb(89, 55, 35), rgb(140, 101, 66),rgb(89, 55, 35),rgb(38, 21, 15)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
		};

		return color;
	}
}

class CatillionareFreegamePickElement extends FreegamePickElement
{
	
	public override AwardElemePrepare()
	{
		super.AwardElemePrepare();
		this.awardElem.style.left = "70px";
		this.awardElem.style.top = "15px";
		this.awardElem.style.fontSize ="50px";
	}
}


//Here is the class for pick elemnt




/**
 * PICK BONUS
 */
class CatillionarePickBonus extends PickBonus
{
}

class CatillionarePickBonusElement extends PickBonusElement
{
}

class CatillionarePickBonusFactory extends PickBonusFactory
{
	public override CreatePickBonus(gameName: string, params: PickBonusParams): PickBonus 
	{
		return new CatillionarePickBonus(gameName, params);
	}

	public override CreatePickElement(params: PickBonusPickElementParams): PickBonusElement 
	{
		return new CatillionarePickBonusElement(params);
	}
}
